import React, { useState } from "react";
import AccordBtn from "../../../../core-components/AccordBtn/AccordBtnUI";
import * as S from "./ImportantInformation.styles";
import { gcBookingReviewScreen, pushCtaOmniEvents } from "../../../../../shared/config/omni";
import { IMPORTANT_INFO_DROPDOWN, MOB_CABS_REVIEW } from "../../../../../shared/utils/util-constants";
import { CTA_TYPE, getActionNameForOmniture } from "../../../../../shared/utils/omni-utils";
import { CABS_REVIEW_PAGE } from "../../../../../shared/utils/util-constants";
import { CABS_REVIEW_ROUTE } from "../../../../../shared/utils/util-constants";

const ImportantInformationUI = ({ header = '', margin, item_list = [] }) => {
  const [toggle, setToggle] = useState(false);

  const handlePolicy = () => {
    if(!toggle){
      pushCtaOmniEvents(getActionNameForOmniture(gcBookingReviewScreen, IMPORTANT_INFO_DROPDOWN, true), CTA_TYPE.HYPER_LINK, CABS_REVIEW_PAGE, CABS_REVIEW_ROUTE)
    }else{
      pushCtaOmniEvents(getActionNameForOmniture(gcBookingReviewScreen, IMPORTANT_INFO_DROPDOWN), CTA_TYPE.HYPER_LINK, CABS_REVIEW_PAGE, CABS_REVIEW_ROUTE)
    }
    setToggle(!toggle);
  };
  return (
    <>
      {item_list?.length ? (
        <S.ImpInfoCont margin={margin}>
          <S.ImpInfoHeader onClick={handlePolicy}>
            <div>{header ? <h3>{header}</h3> : null}</div>
            <AccordBtn active={toggle} />
          </S.ImpInfoHeader>
          {toggle && (
            <S.ImpInfoContent>
              {item_list?.length ? (
                <ul className="infoList">
                  {item_list.map((data, index) => (
                    <li key={`infoList${index}`}>{data}</li>
                  ))}
                </ul>
              ) : null}
            </S.ImpInfoContent>
          )}
        </S.ImpInfoCont>
      ) : null}
    </>
  );
};

export default ImportantInformationUI;
